import { useTranslation } from '@cobliteam/i18n';
import Placeholder from '@cobliteam/ui/components/Placeholder';

const DropdownVehiclesPlaceholder = () => {
  const { t } = useTranslation('multiselects');
  return <Placeholder className='m-5' icon='cb-placeholder-car' text={t('vehicles.no_vehicles_found')} />;
};

export default DropdownVehiclesPlaceholder;
